import type { EvaluationExam, GameMode } from '@interactive-room';
import { listEvaluationExams } from './examStorage';

/** Hub de preparación — asignatura o picker global. */
export function studioHubUrl(subjectId?: string): string {
  return subjectId ? `/studio/asignatura/${encodeURIComponent(subjectId)}` : '/studio';
}

/** Editor full-page de un modo (creación en Studio, no en Consola). */
export function studioModeEditorUrl(mode: GameMode, subjectId?: string): string {
  const params = new URLSearchParams();
  if (subjectId) params.set('subject', subjectId);
  const qs = params.toString();
  return qs ? `/studio/${mode}?${qs}` : `/studio/${mode}`;
}

/** Materiales transmitibles desde Consola — excluye fichas imprimibles (guías). */
export function isConsoleLaunchableExam(exam: EvaluationExam): boolean {
  if (exam.blocks.length === 0) return false;
  if (exam.resourceType === 'guide') return false;
  if (exam.deliveryFormat === 'interactive') return true;
  return exam.resourceType === 'exam' || exam.resourceType === undefined;
}

export function listConsoleLaunchableExams(): EvaluationExam[] {
  return listEvaluationExams().filter(isConsoleLaunchableExam);
}

export function consoleLaunchMaterialLabel(exam: EvaluationExam): string {
  if (exam.deliveryFormat === 'interactive') return 'Clase interactiva';
  return 'Evaluación mixta';
}
